import { MutableRefObject, useRef, useState } from 'react';
import DrawerProvider from './hooks/useDrawer';

import { DrawerProps } from './@types/DrawerProps';
import OpenIconContainer from './handles/OpenIconContainer';
import { Portal } from '@chakra-ui/react';
import DrawerContent from './handles/DrawerContent';
import ChildrenContainer from './handles/ChildrenContainer';
import ToggleContextProvider from './hooks/useToggle';
import './Drawer.scss';
const Drawer = (props: DrawerProps) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const canvasRef = useRef(document.querySelector('.canvas')) as MutableRefObject<HTMLElement>;

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	return (
		<DrawerProvider {...props}>
			<ToggleContextProvider isOpen={isOpen} setIsOpen={setIsOpen}>
				<OpenIconContainer handleClick={handleClick} />

				<Portal containerRef={canvasRef}>
					<DrawerContent isOpen={isOpen}>
						{props.blocks}
						<ChildrenContainer>{props.children}</ChildrenContainer>
					</DrawerContent>
				</Portal>
			</ToggleContextProvider>
		</DrawerProvider>
	);
};

export default Drawer;
